/** Dashboard 页面自行放置 DisconnectDetection，Layout 层不再渲染 */
export const DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT = [
  '/dashboard',
  '/android/dashboard',
  '/android/local/dashboard'
]

/**
 * 当前路径是否使用 Layout 层断连检测（自定义 Dashboard 页返回 false）。
 * @param {string} pathname - Next.js router.pathname
 * @returns {boolean}
 */
export const usesLayoutDisconnectDetection = pathname =>
  !DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT.includes(pathname)

/**
 * 是否应对当前页面启用 Android Local 断连轮询。
 * @param {string} pathname
 * @param {string} currentMode - Redux Common.currentMode
 * @returns {boolean}
 */
export const shouldMonitorDeviceDisconnect = (pathname, currentMode) =>
  currentMode === 'Android-Local' && pathname === '/android/local/dashboard'
